import styled from 'styled-components'

import backgroundDesktop from '~/assets/img/thematic-draw_pascoa_2026/background_desktop.webp'
import backgroundMobile from '~/assets/img/thematic-draw_pascoa_2026/background_mobile.webp'
import { mediaQueries } from '~/assets/styles'

import { Flex, FlexProps } from '~/ds-components'

export type MultipleChoiceDrawBackgroundProps = {
  backgroundImage: string
} & FlexProps

export const MultipleChoiceDrawBackground = styled(Flex)<MultipleChoiceDrawBackgroundProps>`
  align-items: center;
  background: url(${backgroundMobile}) no-repeat center bottom / cover;
  display: flex;
  justify-content: center;
  min-height: 100%;
  padding: 2rem 4rem;

  @keyframes zoomIn {
    0% {
      opacity: 0;
      transform: scale(0.9);
    }
    50% {
      opacity: 0.5;
      transform: scale(1.12);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  header {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 580px;
    width: 100%;

    img {
      aspect-ratio: 1 / 1.144;
      animation: zoomIn 500ms ease-out forwards;
      animation-delay: 100ms;
      display: block;
      margin: auto;
      opacity: 0;
      max-width: 500px;
      width: 50%;
    }

    p {
      animation: zoomIn 500ms ease-out forwards;
      animation-delay: 150ms;
      opacity: 0;
    }
  }

  main button {
    animation: zoomIn 500ms ease-out forwards;
    opacity: 0;

    &:nth-child(1) {
      animation-delay: 350ms;
    }

    &:nth-child(2) {
      animation-delay: 450ms;
    }

    &:nth-child(3) {
      animation-delay: 650ms;
    }

    &:nth-child(4) {
      animation-delay: 550ms;
    }
  }

  @media ${mediaQueries.md} {
    background-image: url(${backgroundDesktop});
    flex-direction: row;

    header img {
      width: 100%;
    }
  }
`
